
import React from 'react';
import Hero from './Hero';
import About from './About';
import Projects from './Projects';
import Hobbies from './Hobbies';

const Home = () => {
    return (
        <>
            <Hero />
            <About />
            <Projects />
            <Hobbies />
        </>
    );
};

export default Home;
